module.exports = __webpack_public_path__ + "static/media/T3.6777dc88.png";